/**
 * Created by hp on 2017/6/6.
 */
import React, {Component} from 'react';
import {connect} from 'react-redux';

import '../styles/component.css';


class CoverImage extends Component {
    constructor() {
        super();
        this.handleClick = this.handleClick.bind(this);
    }

    handleClick() {
        const {coverImage} = this.props;
        this.props.dispatch({
            type: 'MTA_CLICK',
            payload: 'lecture_backtoindex'
        });
        window.location = coverImage.url;
    }

    render() {
        const {coverImage} = this.props;

        return (
            <div className="wk-cp-cover-image background-image"
                    style={{height: coverImage.height + 'px', backgroundImage: `url(${coverImage.image})`}}>
                <div className="icon-to-index" style={{display: 'none'}}>
                    <i className="iconfont icon-zhuye1" onClick={this.handleClick} />
                </div>
            </div>
        );
    }
}

export default connect(state => ({
    coverImage: state.component.coverImage,
}))(CoverImage);


// WEBPACK FOOTER //
// ./src/components/CoverImage.js